import Direction from './direction'
import Operation from './operation'
import RateArticle from './rateArticle'
import Category from './category'
import Type from './type'
import Account from './account'
import Cash from './cash'
import ContragentType from './contragentType'
import Currency from './currency'

export default class PayDictionary {
  constructor() {
    this._loading = true;
    this.$direction = new Direction();
    this.$operation = new Operation();
    this.$rateArticle = new RateArticle();
    this.$category = new Category();
    this.$type = new Type();
    this.$account = new Account();
    this.$cash = new Cash();
    this.$contragentType = new ContragentType();
    this.$currency = new Currency();
  }

  set(data) {
    const self = this;
    self.$operation.set(data.PaymentOperations);
    self.$rateArticle.set(data.RateArticles);
    self.$type.set(data.PaymentTypes);
    self.$account.set(data.PaymentAccounts);
    self.$cash.set(data.Cashes);
    self.$contragentType.set({rc: data.IsReservationCenter, sub: data.IsSubAgent});
    self.$currency.set(data.Currencies);
    self.loading = false;
  }

  get loading() {
    return this._loading ||
      this.$rateArticle.loading ||
      this.$direction.loading ||
      this.$category.loading ||
      this.$type.loading ||
      this.$account.loading ||
      this.$cash.loading ||
      this.$contragentType.loading ||
      this.$currency.loading ||
      this.$operation.loading;
  }

  set loading(value) {
    this._loading = value;
  }

  get rateArticles() {
    return this.$rateArticle.items;
  }

  get directions() {
    return this.$direction.items;
  }

  get operations() {
    return this.$operation.items;
  }

  get categories() {
    return this.$category.items;
  }

  get types() {
    return this.$type.items;
  }

  get accounts() {
    return this.$account.items;
  }

  get cashes() {
    return this.$cash.items;
  }

  get contragentTypes() {
    return this.$contragentType.items;
  }

  get currencies() {
    return this.$currency.items;
  }


}